import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import("@/views/Home/index.vue"),
    },
    {
        path: "/My/Account", //我的账户
        name: "Account",
        component: () => import("@/views/My/Account"),
    },
    {
        path: "/My/Collecting", //我的收藏
        name: "Collecting",
        component: () => import("@/views/My/Collecting"),
    },
    {
        path: "/My/Apply", //我的申请
        name: "Apply",
        component: () => import("@/views/My/Apply"),
    },
    {
        path: "/My/Resume", //个人简历
        name: "Resume",
        component: () => import("@/views/My/Resume"),
    },
    {
        path: "/Jobdetails", //详情
        name: "Jobdetails",
        component: () => import("@/views/Jobdetails"),
    },

    {
        path: "/About", //单位介绍
        name: "About",
        component: () => import("@/views/About"),
    },
    {
        path: "/MailList", //邮箱
        name: "MailList",
        component: () => import("@/views/Mail/MailList"),
    },
    {
        path: "/MailDs", //邮箱详情
        name: "MailDs",
        component: () => import("@/views/Mail/MailDs"),
    },
    {
        path: "/Login", //登录
        name: "Login",
        component: () => import("@/views/Login"),
    },
    {
        path: "/Register", //注册
        name: "Register",
        component: () => import("@/views/Register"),
    },
    {
        path: "/My/Improve", //完善个人资料步骤
        name: "Improve",
        component: () => import("@/views/My/Improve"),
    },
    {
        path: "/My/Admission", //打印准考证
        name: "Admission",
        component: () => import("@/views/My/Admission"),
    },
    {
        path: "/My/SeekerTcp", //用户协议、隐私条款
        name: "SeekerTcp",
        component: () => import("@/views/My/SeekerTcp"),
    },
    {
        path: "/My/ForgetPassword", //忘记密码
        name: "ForgetPassword",
        component: () => import("@/views/My/ForgetPassword"),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router;
